import React from 'react';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Align from '@marvelapp/marvel-ui/align';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Image from 'marketing-website/components/modules/Image';
import assets from 'marketing-website/configs/pages/ios-app-builder/assets';

export default function Integrate() {
  return (
    <Spacing size="xs" sizeM="l" type="padding" position="topBottom">
      <MaxWidth value={720}>
        <Grid columns={2} size="l" alignItems="center" justifyContent="center">
          <GridItem>
            <Spacing size="l" type="padding" position="topBottom">
              <Image {...assets.logosRetina} />
            </Spacing>
          </GridItem>
          <GridItem columnSpan={2} columnSpanM={1}>
            <Align type="center" typeM="left">
              <Spacing size="s" type="padding" position="topBottom">
                <Heading tag="h2" weight="semibold" size="xl">
                  Take it further
                </Heading>
              </Spacing>
              <Paragraph size="l" color="slate">
                You can link your prototype to any website or piece of content
                including surveys on Typeform or Survey Monkey. You can even
                embed YouTube videos inside your prototype.
              </Paragraph>
            </Align>
          </GridItem>
        </Grid>
      </MaxWidth>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/ios-app-builder/integrate.js